import { c as _c } from "react/compiler-runtime";
import type { Entry, UnresolvedLink } from "contentful";
import { AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { isEntry } from "@/lib/contentful/guards";
import type { TypeAccordionItemSkeleton, TypeDuplexSkeleton, TypeEmailFormSkeleton, TypeProseSkeleton, TypeSpecsSkeleton } from "@/types/contentful/generated";
import { AccordionContentBlock } from "./AccordionContentBlock";
type AccordionItemEntry = Entry<TypeAccordionItemSkeleton, undefined, string>;
type ContentBlock = Entry<TypeDuplexSkeleton | TypeEmailFormSkeleton | TypeProseSkeleton | TypeSpecsSkeleton, undefined, string>;
interface Props {
  item: AccordionItemEntry;
}
export function AccordionFullWidthItem(t0) {
  const $ = _c(27);
  const {
    item
  } = t0;
  const {
    heading,
    content,
    anchor
  } = item.fields;
  if (!heading) {
    return null;
  }
  let T0;
  let T1;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[0] !== anchor || $[1] !== content || $[2] !== heading || $[3] !== item.sys.id) {
    const resolvedContent = ((content ?? []) as (ContentBlock | UnresolvedLink<"Entry">)[]).filter(_temp);
    T1 = AccordionItem;
    t3 = item.sys.id;
    t4 = "border-neutral-200";
    if ($[12] !== anchor) {
      t5 = anchor ? {
        id: anchor
      } : {};
      $[12] = anchor;
      $[13] = t5;
    } else {
      t5 = $[13];
    }
    if ($[14] !== heading) {
      t6 = <AccordionTrigger headingLevel="h2" suppressHydrationWarning={true} className="font-semibold text-2xl hover:text-muted-foreground hover:no-underline focus-visible:ring-(--custom-outline) focus-visible:rounded-md">{heading}</AccordionTrigger>;
      $[14] = heading;
      $[15] = t6;
    } else {
      t6 = $[15];
    }
    T0 = AccordionContent;
    t1 = "space-y-6 pb-6 *:px-0";
    t2 = resolvedContent.map(_temp2);
    $[0] = anchor;
    $[1] = content;
    $[2] = heading;
    $[3] = item.sys.id;
    $[4] = T0;
    $[5] = T1;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    T0 = $[4];
    T1 = $[5];
    t1 = $[6];
    t2 = $[7];
    t3 = $[8];
    t4 = $[9];
    t5 = $[10];
    t6 = $[11];
  }
  let t7;
  if ($[16] !== T0 || $[17] !== t1 || $[18] !== t2) {
    t7 = <T0 className={t1}>{t2}</T0>;
    $[16] = T0;
    $[17] = t1;
    $[18] = t2;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== T1 || $[21] !== t3 || $[22] !== t4 || $[23] !== t5 || $[24] !== t6 || $[25] !== t7) {
    t8 = <T1 value={t3} className={t4} {...t5}>{t6}{t7}</T1>;
    $[20] = T1;
    $[21] = t3;
    $[22] = t4;
    $[23] = t5;
    $[24] = t6;
    $[25] = t7;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  return t8;
}
function _temp2(block_0) {
  return <AccordionContentBlock key={block_0.sys.id} block={block_0} />;
}
function _temp(block) {
  return isEntry(block);
}